import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import installElementPlus from './plugins/element'
// import installSwiper from './plugins/swiper'

document.addEventListener('contextmenu', function(event) {
	event.preventDefault(); // 阻止右键菜单的默认行为
});

router.beforeEach((to, from, next) => {
    const userInfo = store.checkLogin()
    if(!userInfo && to.name!='login' && to.name!='login_test' && to.name!='login_ewm' && to.name!='bind_ewm' && to.name!='introduct' && to.name!='login_reset' && to.name!='reset_success' && to.name!='login_findPwd'){
        router.push({
            name: 'login',
            params:{from_path: to.fullPath,from_name:to.name}
        })
        next()
    }else{
        if (to.meta.permission) {
            if (userInfo['permission'].split(',').indexOf('' + to.meta.permission) == -1) {
                console.log('no permission');
            }
        }
        if (to.meta.role) {
            if (to.meta.role != userInfo['role']) {
                console.log('no permission');
            }
        }
        next()
    }
    
});
const app = createApp(App)
installElementPlus(app)
// 全局level变量 1 性能 2功能 3旅途
app.config.globalProperties.$levelId = {
    performance: 1,
    function: 2,    
    trip: 3,
    drive_function:2,
    function2: 4921
}
// installSwiper(app)
app.use(store).use(router).use(VueAxios, axios).mount('#app')